/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, ReactNode, useContext, useState } from 'react';

import { Product } from '@savebetter/components';

type BankProductsProviderProps = { children: ReactNode };
type BankProductsContextProps = {
  contextProducts: Product[] | null;
  setContextProducts: (contextProducts: Product[] | null) => void;
};

const initialValue: BankProductsContextProps = {
  contextProducts: null,
  setContextProducts: _contextProducts => undefined
};

const BankProductsContext = createContext<BankProductsContextProps>(initialValue);

const BankProductsProvider = ({ children }: BankProductsProviderProps) => {
  const [contextProducts, setContextProducts] = useState<Product[] | null>(null);
  return (
    <BankProductsContext.Provider value={{ contextProducts, setContextProducts }}>
      {children}
    </BankProductsContext.Provider>
  );
};

const useBankProducts = () => useContext(BankProductsContext);

export { BankProductsProvider, useBankProducts };
